"use client";

import type { ComponentProps } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";

type ContentImageLightboxProps = {
  open: boolean;
  onOpenChange: NonNullable<ComponentProps<typeof Dialog>["onOpenChange"]>;
  src: string;
  alt: string;
};

export function ContentImageLightbox({
  open,
  onOpenChange,
  src,
  alt,
}: ContentImageLightboxProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTitle className="sr-only">Image preview</DialogTitle>
      <DialogContent className="md:max-w-[1400px]">
        {src ? (
          <div className="flex w-full justify-center">
            {/* Dynamic CMS URLs; <Image> requires known domains / sizes */}
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={src}
              alt={alt}
              className="max-h-[min(85vh,80vw)] w-auto max-w-full object-contain"
            />
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
